const coverageTypes = {
    medical: "medical",
    dental: "dental",
    vision: "vision",
    life: "life",
};

export default coverageTypes;